import React, { useEffect, useState } from "react";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../../assets/css/addunit.css";
import "../../assets/css/mainMenu.css";

import close from "../../assets/icons/close.svg";
import edit from "../../assets/icons/edit.svg";
import recyclebin from "../../assets/icons/recycle-bin2.svg";

import { useNavigate } from "react-router-dom";
import plus1 from "../../assets/icons/plus1.svg";
import search2 from "../../assets/icons/search2.svg";
import ArrowDown from "../../assets/icons2/ArrowDown.svg";
import ArrowUp from "../../assets/icons2/ArrowUp.svg";
import fetchWrapper from "../../AuthMiddleware/FetchWrapper";
import Loader from "../../Components/LoaderAndSpinner/Loader";
import Pagination from "../../Components/Pagination/Pagination";
import { hasPermission } from "../../Services/authUtils";

// import { FaPlus, FaEdit, FaArrowDown, FaArrowUp } from "react-icons/fa";

const Department = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [newDepartment, setNewDepartment] = useState({
    department_code: "",
    department_name: "",
  });

  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [actionDepartmentId, setActionDepartmentId] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortBy, setSortBy] = useState({
    field: "department_code",
    order: "asc",
  });
  const [statusFilter, setStatusFilter] = useState("");
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [allChecked, setAllChecked] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const [bulkDeleteModal, setBulkDeleteModal] = useState(false);
  const [errors, setErrors] = useState({});


  const startIndex = (page - 1) * pageSize + 1;
  const endIndex = Math.min(page * pageSize, totalItems);

  const fetchDepartments = async () => {
    const queryString = `?page=${page}&limit=${pageSize}&sortBy=${sortBy.field}&order=${sortBy.order}&search=${search}&status=${statusFilter}`;
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/department/pagination${queryString}`;


    try {
      const data = await fetchWrapper(
        url,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        },
        navigate
      );



      setDepartments(data.departments);
      setTotalPages(data.totalPages);
      setTotalItems(data.totalItems);
      setCurrentPage(data.currentPage);
    } catch (error) {
      toast.error("Error fetching departments:", error);
    }
  };

  const handleSortChange = (field) => {
    setSortBy((prevSort) => ({
      field,
      order:
        prevSort.field === field && prevSort.order === "asc" ? "desc" : "asc",
    }));
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(1);
  };

  const handleAddDepartment = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/department/create`;

    try {
      const data = await fetchWrapper(
        apiUrl,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newDepartment),
        },
        navigate // Pass navigate here if needed
      );

      setDepartments((prevDepartments) => [...prevDepartments, data]);
      setNewDepartment({ department_code: "", department_name: "" });
      setShowAddModal(false);
      toast.success("Department added successfully");
    } catch (error) {
      setLoading(false); // Ensure loading state is reset in case of an error
      if (error.response) {
        const errorData = error.response;

        setErrors(errorData.errors || {});
        toast.error(errorData.message || "Error adding department");
      } else {
        toast.error("Error adding department");
      }
    } finally {
      setLoading(false);
      fetchDepartments(); // Fetch updated departments
    }
  };

  const handleToggleUserStatus = (departmentId, currentStatus) => {
    setActionDepartmentId(departmentId);
    setActionType(currentStatus ? "delete" : "restore");
    setConfirmModal(true);
  };

  const confirmAction = async () => {
    setLoading(true);

    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/department/delete/${actionDepartmentId}`;

    try {
      await fetchWrapper(
        url,
        {
          method: "POST",
        },
        navigate
      );

      setLoading(false);

      // Update the status of the department
      const updatedDepartments = departments.map((department) =>
        department._id === actionDepartmentId
          ? { ...department, status: actionType === "delete" ? false : true }
          : department
      );
      setDepartments(updatedDepartments); // Update the departments state
      setConfirmModal(false);

      if (actionType === "delete") {
        toast.success("Department Inactivate Successful");
      } else {
        toast.success("Department Restore Successful");
      }
    } catch (error) {
      setLoading(false);

      toast.error(`Error while ${actionType} department`);
    }
  };

  const handleBulkDelete = async () => {
    setLoading(true);

    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/department/delete/${checkedItems[0]}`;

    try {
      await fetchWrapper(
        url,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ids: checkedItems,
          }),
        },
        navigate
      );

      setLoading(false);

      // Update the status of the department
      const updatedDepartments = departments.map((department) =>
        checkedItems.includes(department._id)
          ? { ...department, status: false }
          : department
      );

      setDepartments(updatedDepartments); // Update the departments state
      setBulkDeleteModal(false);
      toast.success(`All the selected items are Inactivated successfully`);
      setAllChecked(!checkedItems);
      setCheckedItems([]);
    } catch (error) {
      setLoading(false);

      toast.error(`Error deleting selected departments`);
    }
  };

  const handleUpdateDepartment = async (e, departmentId, updatedData) => {
    e.preventDefault(); // Prevent page reloading
    setLoading(true);

    // Check if departmentId is defined
    if (!departmentId) {
      setLoading(false);
      toast.error("Department ID is undefined");
      return;
    }

    const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/department/update/${departmentId}`;

    try {
      const data = await fetchWrapper(
        apiUrl,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedData),
        },
        navigate
      );

      setLoading(false);

      const updatedDepartments = departments.map((department) =>
        department._id === departmentId
          ? { ...department, ...data }
          : department
      );
      setDepartments(updatedDepartments);
      toast.success("Department updated successfully");
      setShowEditModal(false);
    } catch (error) {
      setLoading(false);
      if (error.response) {
        const errorData = error.response;

        setErrors(errorData.errors || {});
        toast.error(errorData.message || "Error updating department");
      } else {
        toast.error("Error updating department");
      }
    }
  };



  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      setPage(page);
    }
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setPage(1);
  };
  const handleStatusChange = (status) => {
    setStatusFilter(status === "all" ? "" : status);
    setPage(1); // Reset to the first page when changing status
  };

  const handleHeaderCheckboxChange = () => {
    const newCheckedStatus = !allChecked;
    setAllChecked(newCheckedStatus);
    if (newCheckedStatus) {
      setCheckedItems(
        departments
          .filter((department) => department.status)
          .map((department) => department._id)
      );
    } else {
      setCheckedItems([]);
    }
  };

  const handleRowCheckboxChange = (departmentId) => {
    setCheckedItems((prevCheckedItems) => {
      const isChecked = prevCheckedItems.includes(departmentId);
      const updatedCheckedItems = isChecked
        ? prevCheckedItems.filter((id) => id !== departmentId)
        : [...prevCheckedItems, departmentId];

      setAllChecked(
        updatedCheckedItems.length ===
        departments.filter((department) => department.status).length
      );
      return updatedCheckedItems;
    });
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior if needed
      fetchDepartments(); // Perform search
    }
  };
  useEffect(() => {
    fetchDepartments();
  }, [
    page,
    pageSize,
    sortBy,
    // search,
    // totalPages,
    // currentPage,
    // totalItems,
    // departments.length,
    statusFilter,
    showEditModal,
  ]);

  return (
    <>
      <div className="">
        <div className="container">
          <div className="show-breadcrumb pt-3">
            <div className="">
              <h5>Department</h5>

              <nav className="breadcrumb-nav" aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item ">
                    <a href="#" className="">Configure</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="#" className="">User Settings</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Department
                  </li>
                </ol>
              </nav>
              <div className="">
                <div
                  className="navbar-3 d-flex justify-content-between"
                  style={{ marginTop: "-3px" }}
                >
                  <div className="d-flex gap-3">
                    <div className="search-container ">
                      <img src={search2} alt="Search" />
                      <input
                        type="text"
                        className=""
                        id="search"
                        value={search}
                        onChange={handleSearchChange}
                        onKeyDown={handleKeyDown}
                        placeholder="Search "
                        name="search"
                        autoComplete="off"
                      />
                    </div>
                    {hasPermission(["departments.delete"]) && (
                      <div>
                        {checkedItems.length > 0 && (
                          <button
                            id="bulkDelete"
                            className="bulkDelete-btn"
                            style={{ display: "block" }}
                            onClick={() => setBulkDeleteModal(true)}
                          >
                            <span>
                              <img
                                src={recyclebin}
                                height="24px"
                                width="24px"
                                alt=""
                              />
                            </span>{" "}
                            Inactive
                          </button>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="d-flex gap-3">
                    <div className="dropdown">
                      <select
                        id="cars"
                        className=" select-unit textarea "
                        value={statusFilter}
                        onChange={(e) => handleStatusChange(e.target.value)}
                        style={{
                          width: "120px",
                          height: "calc(100% - 1px)", // Adjust height to be 3px less
                        }}
                      >
                        <option value="">All</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                    {hasPermission(["departments.create"]) && (
                      <div>
                        <button
                          type="button"
                          id="openPopup"
                          className="btn-bg"
                          onClick={() => {
                            setErrors({});
                            setShowAddModal(true);
                          }}
                        >
                          <span className="plus-icon">
                            <img src={plus1} alt="Plus Icon" />
                          </span>
                          Add Department
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                <div style={{ marginTop: "-10px" }}>
                  <div className="table-responsive">
                    <table className="table align-middle table-text">
                      <thead className="table-head align-middle">
                        <tr>
                          <th className="table-check">
                            <input
                              type="checkbox"
                              checked={allChecked}
                              onChange={handleHeaderCheckboxChange}
                            />
                          </th>

                          <th className="col-1 text-uppercase">Id</th>

                          <th
                            className="col text-uppercase"
                            onClick={() => handleSortChange("department_code")}
                          >
                            Code{" "}
                            {sortBy.field === "department_code" && (
                              <span>
                                {sortBy.order === "asc" ? (
                                  <img src={ArrowUp} alt="ArrowUp" />
                                ) : (
                                  <img src={ArrowDown} alt="ArrowDown" />
                                )}
                              </span>
                            )}
                          </th>
                          <th
                            className="col text-uppercase"
                            onClick={() => handleSortChange("department_name")}
                          >
                            Name{" "}
                            {sortBy.field === "department_name" && (
                              <span>
                                {sortBy.order === "asc" ? (
                                  <img src={ArrowUp} alt="ArrowUp" />
                                ) : (
                                  <img src={ArrowDown} alt="ArrowDown" />
                                )}
                              </span>
                            )}
                          </th>
                          <th className="col text-uppercase">Status</th>
                          {(hasPermission(["departments.update"]) ||
                            hasPermission(["departments.delete"])) && (
                              <th className="col-2 text-uppercase">Action</th>
                            )}
                        </tr>
                      </thead>
                      <tbody className="pl-4">
                        {departments.map((department, index) => (
                          <tr
                            key={department._id}
                            className={
                              department.status ? "" : " disabled text-muted"
                            }
                          >
                            <td className="table-check">
                              <input
                                type="checkbox"
                                checked={checkedItems.includes(department._id)}
                                onChange={() =>
                                  handleRowCheckboxChange(department._id)
                                }
                                disabled={!department.status}
                              />
                            </td>

                            <td className="col">{index + startIndex}</td>
                            <td className="col ">
                              {department.department_code}
                            </td>
                            <td className="col">
                              {department.department_name}
                            </td>
                            <td className="col">
                              {department.status ? (
                                <span className="active-status">Active</span>
                              ) : (
                                <span className="inactive">Inactive</span>
                              )}
                            </td>
                            {(hasPermission(["departments.update"]) ||
                              hasPermission(["departments.delete"])) && (
                                <td>
                                  <div className="action-icons d-flex justify-content-left align-items-center ">
                                    {department.status &&
                                      hasPermission(["departments.update"]) && (
                                        <button
                                          style={{
                                            border: "none",
                                            background: "transparent",
                                          }}
                                          className="align-content-center me-3"
                                          onClick={() => {
                                            setErrors({});
                                            setSelectedDepartment(department);
                                            setShowEditModal(true);
                                          }}
                                          disabled={!department.status}
                                        >
                                          <img src={edit} alt="edit" />
                                        </button>
                                      )}

                                    {hasPermission(["departments.delete"]) && (
                                      <span className="align-content-center switcher">
                                        <label className="switch switch1">
                                          <input
                                            type="checkbox"
                                            checked={department.status}
                                            onChange={() =>
                                              handleToggleUserStatus(
                                                department._id,
                                                department.status
                                              )
                                            }
                                          />
                                          <span className="slider slider1 round"></span>
                                        </label>
                                      </span>
                                    )}
                                  </div>
                                </td>
                              )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  pageSize={pageSize}
                  onPageSizeChange={handlePageSizeChange}
                  totalItems={totalItems}
                  startIndex={startIndex}
                  endIndex={endIndex}
                />
              </div>
            </div>
          </div>
          {/* Add Modal */}
          <div
            id="overlay"
            className={`modal fade ${showAddModal ? "show" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{
              zIndex: 30,
              display: showAddModal ? "block" : "none",
              transition: "width 2s",
            }}
          >
            {loading ? (
              <Loader />
            ) : (
              <div>
                <div className="addunit-card Width 25%">
                  <div className="addunit-header">
                    <h4>Add Department</h4>
                    <button
                      style={{ border: "none", backgroundColor: "inherit" }}
                      type="button"
                      className="close"
                      onClick={() => {
                        setNewDepartment({
                          department_code: "",
                          department_name: "",
                        });
                        setShowAddModal(false);
                      }}
                    >
                      <img src={close} width="28px" height="28px" alt="Close" />
                    </button>
                  </div>

                  <form
                    onSubmit={handleAddDepartment}
                    noValidate
                    className="needs-validation"
                  >
                    <div className="addunit-form">
                      <div className="row">
                        <div className="d-flex flex-column mb-4">
                          <label htmlFor="code" className="addunit-form-text">
                            Department Code{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${errors.department_code ? "is-invalid" : ""
                              }`}
                            id="validationCustomUsername1"
                            placeholder="Enter Code"
                            value={newDepartment.department_code}
                            onChange={(e) =>
                              setNewDepartment({
                                ...newDepartment,
                                department_code: e.target.value,
                              })
                            }
                          />
                          {errors.department_code && (
                            <div className="invalid-feedback">
                              {errors.department_code}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="d-flex flex-column mb-4">
                          <label htmlFor="name" className="addunit-form-text">
                            Department Name{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${errors.department_name ? "is-invalid" : ""
                              }`}
                            id="validationCustomUsername"
                            placeholder="Enter Name"
                            value={newDepartment.department_name}
                            onChange={(e) =>
                              setNewDepartment({
                                ...newDepartment,
                                department_name: e.target.value,
                              })
                            }
                          />
                          {errors.department_name && (
                            <div className="invalid-feedback">
                              {errors.department_name}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="addunit-card-footer justify-content-between">
                      <button
                        type="button"
                        className="discard-btn"
                        onClick={() => {
                          setNewDepartment({
                            department_code: "",
                            department_name: "",
                          });
                          setShowAddModal(false);
                        }}
                      >
                        Close
                      </button>
                      <button type="submit" className="update-btn">
                        Add
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>

          {/* Edit Modal */}
          <div
            id="overlay"
            className={`modal fade ${showEditModal ? "show" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{
              zIndex: 30,
              display: showEditModal ? "block" : "none",
              transition: "width 2s",
            }}
          >
            {loading ? (
              <Loader />
            ) : (
              <div>
                <div className="addunit-card Width 25%">
                  <div className="addunit-header">
                    <h4>Edit Department</h4>
                    <button
                      style={{ border: "none", backgroundColor: "inherit" }}
                      type="button"
                      className="close"
                      onClick={() => setShowEditModal(false)}
                    >
                      <img src={close} width="28px" height="28px" alt="Close" />
                    </button>
                  </div>

                  <form
                    noValidate
                    className="needs-validation"
                    onSubmit={(e) =>
                      handleUpdateDepartment(
                        e, // Pass the event object here
                        selectedDepartment?._id,
                        selectedDepartment
                      )
                    }
                  >
                    <div className="addunit-form">
                      <div className="row">
                        <div className="d-flex flex-column mb-4">
                          <label
                            htmlFor="editCode"
                            className="addunit-form-text"
                          >
                            Department Code{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${errors.department_code ? "is-invalid" : ""
                              }`}
                            id="editCode"
                            placeholder="Enter Code"
                            value={selectedDepartment?.department_code || ""}
                            onChange={(e) =>
                              setSelectedDepartment({
                                ...selectedDepartment,
                                department_code: e.target.value,
                              })
                            }
                          />
                          {errors.department_code && (
                            <span className="invalid-feedback">
                              {errors.department_code}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="row">
                        <div className="d-flex flex-column mb-4">
                          <label
                            htmlFor="editName"
                            className="addunit-form-text"
                          >
                            Department Name{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${errors.department_name ? "is-invalid" : ""
                              }`}
                            id="editName"
                            placeholder="Enter Name"
                            value={selectedDepartment?.department_name || ""}
                            onChange={(e) =>
                              setSelectedDepartment((prevDepartment) => ({
                                ...prevDepartment,
                                department_name: e.target.value,
                              }))
                            }
                          />
                          {errors.department_name && (
                            <span className="invalid-feedback">
                              {errors.department_name}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="addunit-card-footer">
                      <button
                        type="button"
                        className="discard-btn"
                        onClick={() => setShowEditModal(false)}
                      >
                        Close
                      </button>
                      <button type="submit" className="update-btn">
                        Save Changes
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>

          {/* Confirmation Modal */}
          <div
            id="overlay"
            className={`modal fade ${confirmModal ? "show" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{
              zIndex: 30,
              display: confirmModal ? "block" : "none",
              transition: "width 2s",
            }}
          >
            {loading ? (
              <Loader />
            ) : (
              <div>
                <div className="addunit-card Width 25%">
                  <div className="addunit-header">
                    <h4>
                      {actionType === "restore" ? "Restore" : "Inactivate"}{" "}
                      Department
                    </h4>
                    <button
                      style={{ border: "none", backgroundColor: "inherit" }}
                      type="button"
                      className="close"
                      onClick={() => setConfirmModal(false)}
                    >
                      <img src={close} width="28px" height="28px" alt="Close" />
                    </button>
                  </div>
                  <div className="addunit-form">
                    <p>
                      Are you sure you want to{" "}
                      {actionType === "restore" ? "restore" : "inactivate"} this
                      department?
                    </p>
                  </div>
                  <div className="addunit-card-footer justify-content-between">
                    <button
                      type="button"
                      className="discard-btn"
                      onClick={() => setConfirmModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="update-btn"
                      onClick={confirmAction}
                    >
                      {actionType === "restore" ? "Restore" : "Inactivate"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Bulk Delete Modal */}
          <div
            id="overlay"
            className={`modal fade ${bulkDeleteModal ? "show" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{
              zIndex: 30,
              display: bulkDeleteModal ? "block" : "none",
              transition: "width 2s",
            }}
          >
            {loading ? (
              <Loader />
            ) : (
              <div>
                <div className="addunit-card Width 25%">
                  <div className="addunit-header">
                    <h4>Bulk Inactivate</h4>
                    <button
                      style={{ border: "none", backgroundColor: "inherit" }}
                      type="button"
                      className="close"
                      onClick={() => setBulkDeleteModal(false)}
                    >
                      <img src={close} width="28px" height="28px" alt="Close" />
                    </button>
                  </div>
                  <div className="bulk-delete-unit">
                    <img src={recyclebin} width="48px" height="48px" alt="" />

                    <h4 className="delete-unit-h4">Inactivate Departments</h4>
                    <p className="delete-unit-text">
                      Are you sure you want to inactivate all the selected
                      departments?
                    </p>
                  </div>
                  <div className="addunit-card-footer justify-content-between">
                    <button
                      type="button"
                      className="discard-btn"
                      onClick={() => setBulkDeleteModal(false)}
                    >
                      CANCEL
                    </button>
                    <button
                      type="button"
                      className="update-btn"
                      onClick={handleBulkDelete}
                    >
                      CONFIRM
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <ToastContainer autoClose={2000} position={"top-right"} />
    </>
  );
};

export default Department;
